import { SERVER_URL } from "../constants";
import { getToken } from "../user/User";

export default async function SuspendOrg(id) {
  var response;
  var myHeaders = new Headers();
  myHeaders.append("Accept", "application/json");
  myHeaders.append("Authorization", "Bearer "+getToken());

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    redirect: 'follow'
  };

  response = await fetch(SERVER_URL + "api/organizations/"+id+"/suspend", requestOptions);
  if (response.status === 200||response.status === 201) return response.json();
  return false;
}
